import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DriverService } from '../driver/services/driver.service';
import { BookingFlowService } from '../booking-flow/service/booking-flow.service';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { MSG_BOOKING_CONFIRMATION, USER_ROLES } from '@shared/constant/shared.constant';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { PaymentSucessComponent } from '../booking-flow/payment-success/payment-success.component';
import { CommonFunctions } from '@shared/common-functions';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-modify-payment-popup-modal',
  templateUrl: './modify-payment-popup-modal.component.html',
  styleUrls: ['./modify-payment-popup-modal.component.scss'],
})
export class ModifyPaymentModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  driverId: any;
  bookingType: any;
  bookingId: any;
  paymentMethodDetails: any[];
  paymentMethodSelected: any;
  prefereedPaymentMethodId: any;
  displayedPaymentMethods: any[];
  viewMore: any;
  updatedBookingData: any;
  isPaymentMethodValid: boolean = false;
  previouslySelectedPaymentMethod: any;
  previousPaymentMethodCardAch: null;
  isPreferredPaymentSelected: boolean = true;
  selectedPaymentMethod: any = null;
  departureDateTime: any;
  arrivalDateTime: any;
  slotId: any;
  updatedPaymentMethod: any;
  userRoles = USER_ROLES;
  assisstedListUrl: string;
  userType: any;
  constructor(
    public readonly config: DynamicDialogConfig,
    private readonly driverService: DriverService,
    private readonly bookingFlowService: BookingFlowService,
    private readonly ref: DynamicDialogRef,  
    private readonly dialogControlService: DialogControlService,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit() {
    this.updatedBookingData = this.config.data.data;
    this.slotId = this.config.data.slotId;
    this.departureDateTime = this.config.data.departureDateTime;
    this.arrivalDateTime = this.config.data.arrivalDateTime;
    this.driverId = this.config.data.driverId;
    this.bookingType = this.config.data.bookingType;
    this.bookingId = this.config.data.bookingId;
    this.userType = this.config.data.userType
    this.getAllPaymentList(this.driverId);
  }

  getAllPaymentList(DriverId) {
    this.driverService.getAllPatmentMethodsList(DriverId)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        const cards = response.data['cards'] || [];
        let banks = response.data['banks'] || [];

        if (this.bookingType === 0) {
          banks = []; // Remove bank objects if bookingType is 0
        }
        let defaultPayment;

        if (this.bookingType === 0) {
          defaultPayment = null; // Do not set default payment method
        }

        if (defaultPayment?.type === 'card') {
          this.paymentMethodDetails = [...cards, ...banks]; // Show cards first
        } else if (defaultPayment?.type === 'us_bank_account') {
          this.paymentMethodDetails = [...banks, ...cards]; // Show banks first
        } else {
          this.paymentMethodDetails = [...cards, ...banks]; // Default order if no default payment
        }
        // Move default payment method to the first position if it exists and bookingType is not 0
        if (defaultPayment) {
          this.paymentMethodDetails = this.paymentMethodDetails.filter(
            (p) => p !== defaultPayment
          );
          this.paymentMethodDetails.unshift(defaultPayment);
        }

        // Set selected payment method (only if bookingType is not 0)
        this.paymentMethodSelected =
          this.bookingType === 0 ? null : defaultPayment;
        this.updateDisplayedPayments();
        this.prefereedPaymentMethodId = this.paymentMethodSelected?.id;
        
      },
      error: (_error) => {
        this.displayedPaymentMethods = [];
        this.isPreferredPaymentSelected = false;
      },
    });
  }
  close() {
    this.ref.close();
  }

  viewMoreToggal() {
    this.viewMore = !this.viewMore;
    this.updateDisplayedPayments();
  }

  updateDisplayedPayments() {
    this.displayedPaymentMethods = this.viewMore
      ? this.paymentMethodDetails // Show all if "View More" is clicked
      : this.paymentMethodDetails.slice(0, 2); // Show only first 2 items initially
  }

  onPreferredCheck(data) {
    this.isPaymentMethodValid = false;
    if (!data) {
      // Store the current selection before clearing it
      this.previouslySelectedPaymentMethod = this.paymentMethodSelected;
      this.prefereedPaymentMethodId = null;
      if (this.previousPaymentMethodCardAch != null) {
        this.updatedPaymentMethod = this.previousPaymentMethodCardAch;
      }
    } else {
      // Restore the previous selection if it exists
      if (this.previouslySelectedPaymentMethod) {
        this.paymentMethodSelected = this.previouslySelectedPaymentMethod;
        this.prefereedPaymentMethodId = this.previouslySelectedPaymentMethod.id;
        this.updatedPaymentMethod = this.previouslySelectedPaymentMethod.type === 'card' ? 1 : 2;
      }
    }
  }

  getSelectedPaymentMethod(data) {
    this.previousPaymentMethodCardAch = data;
    this.selectedPaymentMethod = data;
    this.updatedPaymentMethod = data;
    this.isPaymentMethodValid = false;
  }

  onPaymentChange(event) {
    if (this.isPreferredPaymentSelected) {
      this.paymentMethodSelected = event;
      this.prefereedPaymentMethodId = event.id;
    }
    this.updatedPaymentMethod = event.type === 'card' ? 1 : 2;
    this.isPaymentMethodValid = false;
  }

  payNowButton() {
    if(this.updatedPaymentMethod){
      
      let request = {
        bookingId: this.bookingId,
        arrivalDateTime: this.arrivalDateTime,
        departureDateTime: this.departureDateTime,
        slotId: this.slotId,
        paymentMethod: this.updatedPaymentMethod,
        isPreferredPaymentMethod: this.isPreferredPaymentSelected ? true : false,
        preferredPaymentMethodId: this.isPreferredPaymentSelected
          ? this.prefereedPaymentMethodId
          : null,
        timezone: Utility.getLocalTimeZone(),
      };
      this.bookingFlowService.updateBookingById(request)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          
          if(response.url){
            window.location.href = response.url;
          }
          if(response.isDefaultPaymentSuccessfull === true){
             this.assistedListUrl();
                      
                      this.dialogControlService.openDialog(PaymentSucessComponent, {
                        width: '30%',
                        data: {
                          assistedUrl: this.assisstedListUrl,
                          bodyText: MSG_BOOKING_CONFIRMATION,
                          buttonText: 'OK',
                          heading: 'Payment Initiated',
                          bookingId: this.bookingId,
  
                        },
                      });
          }
          this.close();
        }
      });
    } else {
      this.isPaymentMethodValid = true;
      CommonFunctions.gotoTop();
    }
 
  }

  assistedListUrl() {
    let roleName = this.encryptStorage.getItem('roleName');
    let bookingDetailsPath =
      this.userType === 'Parker'
        ? 'booking-details'
        : 'group-booking-details';

    switch (roleName) {
      case this.userRoles.SUPER_ADMIN:
        this.assisstedListUrl = `super-admin/${bookingDetailsPath}`;
        break;
      case this.userRoles.PARKING_MANAGER:
      case this.userRoles.PARKING_OWNER:
        this.assisstedListUrl = `manager/${bookingDetailsPath}`;
        break;
    }
  }
}
